import React from 'react';
import classnames from 'classnames';
import styles from './LoaderDashboard.module.scss';

interface LoaderFragmentProps {
  id: String;
}

const Circle: React.FC<LoaderFragmentProps> = ({ id }) => {
  return (
    <div
      className={classnames(styles.circle, {
        [styles[`${id}`]]: id,
      })}
    />
  );
};

const Bar: React.FC<LoaderFragmentProps> = ({ id }) => {
  return (
    <div
      className={classnames(styles.bar, {
        [styles[`${id}`]]: id,
      })}
    />
  );
};

const HeadingBlock = () => {
  return <Bar id="headingBlock" />;
};

const BreadcrumbBlock = () => {
  return <Bar id="breadcrumbBlock" />;
};

const ItemBlock = () => {
  return (
    <div className={styles.itemBlock}>
      <div className={styles.col1}>
        <div className={styles.file} />
        <Circle id="avatar" />
      </div>
      <div className={styles.col2}>
        <Bar id="bar__1" />
        <Bar id="bar__2" />
      </div>
      <div className={styles.col3}>
        <div className={styles.collaborators}>
          <Circle id="collaborator" />
          <Circle id="collaborator" />
          <Circle id="collaborator" />
        </div>
        <div className={classnames(styles.oval, styles.integration)} />
      </div>
    </div>
  );
};

interface LoaderDashboardProps {
  layout: String;
}

export const LoaderDashboard: React.FC<LoaderDashboardProps> = ({ layout }) => {
  return (
    <div
      className={classnames(layout === 'Boot' ? styles.bootContainer : styles.container, {
        [styles[`layout-${layout}`]]: layout,
      })}
    >
      {layout === 'Boot' && (
        <>
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'Feed' && (
        <>
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'IntegrationFeed' && (
        <>
          <BreadcrumbBlock />
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'SearchFeed' && (
        <>
          <BreadcrumbBlock />
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'Results' && (
        <>
          <HeadingBlock />
          <HeadingBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'HeadlessFeed' && (
        <>
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'GroupActivityFeed' && (
        <>
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
          <ItemBlock />
        </>
      )}

      {layout === 'GroupPinnedFeed' && (
        <>
          <ItemBlock />
          <ItemBlock />
        </>
      )}
    </div>
  );
};
